import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'

import { projectContext, loadingContext, unfolder, urlValue, onImportExcelAsync, downloadFileNew, useTranslate } from '../lib'
import SideBar from '../components/SideBar'
import { AnswerCRUD } from '../components/AnswerCRUD'

import '../styles/answers.scss'
import { customModal } from '../styles/customModal'
import TitleBar from "../components/TitleBar";
import CheckBox2 from '../components/CheckBox2'
import Loading from '../components/Loading'
import BoxInfo from '../components/common/BoxInfo'
import { Tooltip } from 'react-tooltip'
import Button from '../components/provider/button/button.jsx' 

export default function Answers() {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [answers, setAnswers] = useState([])
  const [isModalOpen, setIsModalOpen] = useState({ delete: false, code: false })
  const [selectedAnswer, setSelectedAnswer] = useState({ content: {} })
  const [sidePanel, setSidePanel] = useState('detail')
  const ref = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const [sort, setSort] = useState('asc')
  const { t } = useTranslate();
  useEffect(() => {
    getAnswers();
  }, [sidePanel])

  const getAnswers = ()=>{
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/project/${selectedProject.id}/answers`,
      headers: {
        user: id,
        'access-token': token,
      },
    })
      .then(function (response) {
        setAnswers(response.data)
        setLoading(false)
      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
      })
  }

  const getAnswersWithoutLoading = async () => {
    try {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
      
      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/project/${selectedProject.id}/answers`,
        headers: {
          user: id,
          'access-token': token,
        },
      });

      setAnswers([...response.data]);
      return response.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  function handleAnswer(answer) {
    setSidePanel('edit')
    setSelectedAnswer(answer)
  }

  function openModal(answer) {
    setIsModalOpen({ delete: true, code: false })
    setSelectedAnswer(answer)
  }

  const deleteAnswer = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let ccms_id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').ccms_name
    setLoading(true)
    axios({
      method: 'post',
      url: `${urlValue}/studio/answer/${selectedAnswer.id}/delete`,
      headers: {
        user: id,
        'Content-Type': 'application/json',
        'access-token': token,
        projectid: selectedProject.id,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        'ccms_name': ccms_id, 
        'user_id': id ,
        'project': selectedProject.id,
        'name': selectedAnswer.name 
      },
    })
      .then(async function (response) {
        await getAnswersWithoutLoading();
        await initializeAnswerOrders();

        setSidePanel('new')
        setSelectedAnswer({ content: {} })
        setLoading(false)
        setIsModalOpen({ delete: false, code: false })
      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
        setIsModalOpen({ delete: false, code: false })
      })
  }

  const newAnswer = () => {
    setSelectedAnswer({ content: {} })
    setSidePanel('new')
  }


  const [answersDelete, setanswersDelete] = useState([]);
  const [modalDelete, setModalDelete] = useState(false);
  const selectForDelete = (e, item) => {
    if (e.target.checked) {
      setanswersDelete([...answersDelete, item])
    } else {
      setanswersDelete(answersDelete.filter(x => x.id !== item.id));
    }
  }

  const selectAll = (e) => {
    if (e.target.checked) {
      document.querySelectorAll("#answer-all input[type='checkbox']").forEach((item) => {
        item.checked = true;
      })
    } else {
      document.querySelectorAll("#answer-all input[type='checkbox']").forEach((item) => {
        item.checked = false;
      })
    }
  }

  const deleteMultiple = async () => {
    try {
      if (answersDelete.length > 0) {

        let newArrayAnswersToDelete = [];
        let uniqueObject = {};
        let objTitle = '';

        for (let i in answersDelete) {
          // Extraction the title
          objTitle = answersDelete[i]['id'];

          // Here we use the title as the index
          uniqueObject[objTitle] = answersDelete[i];
        }

        for (let i in uniqueObject) {
          newArrayAnswersToDelete.push(uniqueObject[i]);
        }

        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        let result;
        for (let i = 0; i < newArrayAnswersToDelete.length; i++) {
          result = await axios.post(`${urlValue}/studio/answer/${newArrayAnswersToDelete[i].id}/delete`
            , {
              headers: {
                user: id,
                'Content-Type': 'application/json',
                'access-token': token,
                projectid: selectedProject.id,
                'X-CSRF-Token': csrfToken
              },
              withCredentials: true,
            });
        }

        await getAnswersWithoutLoading();
        await initializeAnswerOrders();

        setModalDelete(false)
        getAnswers();
        //window.location.reload();
      }
    } catch (error) {
      setModalDelete(false)
    }
  }

  const sortElementsChange = (e) => {
    setSort(e.target.value);
  }

  const sortElements = () => {
    let sortOrder = sort;
    let result;
  
    if (answers.some(a => a.order !== null && a.order !== undefined)) {
      switch (sortOrder) {
        case 'asc':
          result = (a, b) => {
            if (a.order !== null && a.order !== undefined && b.order !== null && b.order !== undefined) {
              return a.order - b.order;
            }
            else if (a.order !== null && a.order !== undefined) {
              return -1;
            }
            else if (b.order !== null && b.order !== undefined) {
              return 1;
            }
            else {
              return a.name > b.name ? 1 : -1;
            }
          };
          break;
        case 'desc':
          result = (a, b) => {
            if (a.order !== null && a.order !== undefined && b.order !== null && b.order !== undefined) {
              return b.order - a.order;
            }
            else if (a.order !== null && a.order !== undefined) {
              return -1;
            }
            else if (b.order !== null && b.order !== undefined) {
              return 1;
            }
            else {
              return a.name < b.name ? 1 : -1;
            }
          };
          break;
      }
    } else {
      switch (sortOrder) {
        case 'asc':
          result = (a, b) => a.name > b.name ? 1 : -1;
          break;
        case 'desc':
          result = (a, b) => a.name < b.name ? 1 : -1;
          break;
      }
    }
  
    return result;
  };

  const sortByOrder = async () => {
    try {
      //setLoading(true);
      
      await initializeAnswerOrders();
      
      if (sort !== 'asc') {
        setSort('asc');
      }
      
      getAnswers();
      
    } catch (error) {
      console.error("Error sorting by order:", error);
    } finally {
      //setLoading(false);
    }
  };

  // const [AnswersExcel, setAnswersExcel] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false)

  useEffect(() => {
    document.querySelectorAll("#answer-all input[type='checkbox']").forEach((item) => {
      item.checked = false;
    })
  }, [answers])
  const uploadMaxive = async (AnswersExcel) => {
    if (!loadingUpload && AnswersExcel.length > 0 && AnswersExcel.length <= 101) {

      setLoadingUpload(true)
      setTimeout(async () => {
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        for (var i = 0; i < AnswersExcel.length; i++) {
          const rest = await axios({
            method: 'post',
            url: `${urlValue}/studio/answer`,
            headers: {
              user: id,
              'Content-Type': 'application/json',
              'access-token': token,
              projectid: selectedProject.id,
              'X-CSRF-Token': csrfToken
            },
            withCredentials: true,
            data: {
              id: null,
              code: AnswersExcel[i].Code,
              name: AnswersExcel[i].Name?.trim(),
              type: parseInt(AnswersExcel[i].Type),
              content: {
                text: AnswersExcel[i].Content,
              },
              technical_text: AnswersExcel[i].Technical_Text,
              locale: AnswersExcel[i].Locale,
              project: selectedProject.id,
              channel: 1,
              edited_by: null,
              last_update: '2022-02-24',
              transactional: 0,
              webhook: null,
            },
          })
        }

        window.location.reload();
      }, 1000)

    } else {
      alert(t('alerts.intentExcelLimit'))
    }

  }
  const prepareExcel = async (file) => {
    const DatosExcel = await onImportExcelAsync(file);
    // setAnswersExcel(DatosExcel);
    uploadMaxive(DatosExcel);
  }

  const updateAnswerOrder = (answerId, newOrder) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    
    return axios({
      method: 'post',
      url: `${urlValue}/studio/answer/order/update`,
      headers: {
        user: id,
        'Content-Type': 'application/json',
        'access-token': token,
        projectid: selectedProject.id,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        id: answerId,
        order: newOrder,
        project: selectedProject.id
      },
    })
  }

  const initializeAnswerOrders = async () => {
    try {
      //setLoading(true);
      
      const sortedAnswers = [...answers].sort(sortElements());
      const updatePromises = [];

      sortedAnswers.forEach((answer, index) => {
        updatePromises.push(
          updateAnswerOrder(answer.id, index + 1)
        );
      });
      
      if (updatePromises.length > 0) {
        await Promise.all(updatePromises);
        await getAnswersWithoutLoading();
      }
      
    } catch (error) {
      console.error("Error initializing order:", error);
    } finally {
      //setLoading(false);
    }
  }

  const moveUp = async (e, answer, index) => {
    e.stopPropagation();
    e.preventDefault();
    
    try {
      const currentAnswers = await getAnswersWithoutLoading();
      const sortedAnswers = [...currentAnswers].sort(sortElements());
      
      const currentIndex = sortedAnswers.findIndex(a => a.id === answer.id);
      if (currentIndex <= 0) return;
      
      const newArrangement = [...sortedAnswers];
      const itemToMove = newArrangement.splice(currentIndex, 1)[0];
      newArrangement.splice(currentIndex - 1, 0, itemToMove);
      
      const updatePromises = newArrangement.map((ans, idx) => 
        updateAnswerOrder(ans.id, idx + 1)
      );
      
      await Promise.all(updatePromises);
      
      await getAnswersWithoutLoading();
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  const moveDown = async (e, answer, index) => {
    e.stopPropagation();
    e.preventDefault();
    
    try {
      const currentAnswers = await getAnswersWithoutLoading();
      const sortedAnswers = [...currentAnswers].sort(sortElements());
      
      const currentIndex = sortedAnswers.findIndex(a => a.id === answer.id);
      if (currentIndex >= sortedAnswers.length - 1) return;
      
      const newArrangement = [...sortedAnswers];
      const itemToMove = newArrangement.splice(currentIndex, 1)[0];
      newArrangement.splice(currentIndex + 1, 0, itemToMove);
      
      const updatePromises = newArrangement.map((ans, idx) => 
        updateAnswerOrder(ans.id, idx + 1)
      );
      
      await Promise.all(updatePromises);
      
      await getAnswersWithoutLoading();
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  const handleAnswerUpdated = async () => {
    console.log("Actualizando lista de respuestas...");
    await getAnswersWithoutLoading();
  };

  useEffect(() => {
    answers.forEach(answer => {
      const orderElement = document.getElementById(`order_number_${answer.id}`);
      if (orderElement) {
        orderElement.textContent = answer.order !== null && answer.order !== undefined ? 
          `#${answer.order}` : '#0';
      }
    });
  }, [answers]);

  return (
    <div>
      <section className="container-answers general-container" id="container-adj">
        <SideBar active={'Answers'} />
        <div className="container">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <div className="container-info">
            <div className="header con_header">
              <div className="title"> 
              <div className="answers">
                  <div className="project-name-container m-1">
                    {/* <div className="icon"></div> */}
                    <h2 style={{paddingLeft: 0}}>{selectedProject.name}</h2>
                  </div>
                  <div className="separator">-</div>
                  <div className='answers m-1'>
                    <h1 style={{color: "#0B5FA3"}}>{t('answers.answers')}</h1>
                  </div>

                </div>

                <div className="head"> 
                  <div className="flex items-center justify-end">

                    <div style={{cursor: 'pointer'}}  onClick={()=>{downloadFileNew("FormatAnswers.xlsx")}} 
                      className="a-download trans btn-excel"     >
                      <img src="/icons/download-icon.svg" alt="newAns" style={{ width: 15 }} />
                      <span>{t('answers.downloadTemplate')}</span>
                      <BoxInfo
                        id="downloadexc-tp"
                        titleClass='mr-0-1 color-label f-16  title-intent'
                        title=""
                        place="top"
                        containerClass='mr-0-1  '
                        render={t('answers.downloadTemplateTooltip')}
                      />
                    </div>

                    
                    <div className="upload-excel upload-btn btn-excel trans ml-2">
                      {loadingUpload ? <Loading /> : <>
                        <img src="/icons/excel.svg" alt="newAns" style={{ width: 15 }} />
                        <label> {t('menu.uploadExcel')}</label>

                      </>}

                      <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />

                      <BoxInfo
                        id="uploadexc-tp"
                        titleClass='mr-0-1 color-label f-16  title-intent'
                        title=""
                        place="top"
                        containerClass='mr-0-1  '
                        render={t('alerts.uploadExcelTooltip')}
                      />
                    </div>
                    

                    {/* <div className="input">
                        <div onClick={() => { uploadMaxive() }} className="a-download upload-btn trans"   >
                          <div className='btn-loanding'>
                            {loadingUpload ? <Loading /> : <div>Upload Intents</div>}
                          </div>

                        </div>
                      </div> */}
                  </div>

                  <Button 
                    type="button"
                    id='new-tp'
                    label={t('menu.newAnswers')}
                    onClick={() => newAnswer()}
                    className="buttonE w-auto"
                    content={t('menu.createNewAnswer')}
                    style={{ border: "none", marginLeft: 6 }}
                  />

                  <Button 
                    type="button"
                    id='delete-tp'
                    label={t('common.delete')}
                    onClick={() => setModalDelete(true)}
                    className="buttonH"
                    content={t('menu.deleteAnswersTooltip')}
                    style={{ border: "none", marginLeft: 6}}
                  />

                </div>
              </div>

            </div>

            <div className="body left-c" id="answer-all">
              <div className="d-flex flex-row justify-space-between align-items-center">

                <div className="home-search ml-3 bg-white d-flex flex-row align-items-center justify-space-between"
                  style={{ borderRadius: 20, backgroundColor: 'white', width: 200, border: '1px solid gray' }}>
                  <input
                    type="text"
                    placeholder={t('common.search')}
                    onChange={event => {
                      setSearch(event.target.value)
                    }}
                    className="p-2 home-search"
                    style={{ border: 'none', marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                  />
                  <div className="p-1 pr-5 mt-1">
                    <img src="/icons/search.svg" style={{ width: 16, minWidth: 16, marginLeft: -8 }} alt='' />
                  </div>
                </div>

                <div className="d-flex flex-row align-items-center justify-end">
                  <label htmlFor="sort" className='title-search'>{t('common.organize')} :</label>
                  <select onChange={sortElementsChange} name="" id="sort" className="select-nesting"
                    style={{ border: '1px solid gray', fontSize: 13, borderRadius: 20, marginLeft: 8,
                      padding: '0 20px', minWidth: 100, backgroundPositionX: "80%", height: 30 }}>
                    <option value="asc" style={{ padding: 5 }} selected>{t('common.asc')} </option>
                    <option value="desc" style={{ padding: 5 }}>{t('common.desc')} </option>
                  </select>
                </div>
              </div>

              <div className="elements mt-3 scroll-panel-left" ref={ref}>
                {answers.length > 0 &&
                  <div className='rounded-md   flex items-center' style={{ marginLeft: 20, marginRight: 20, paddingLeft: 15 }}>
                    <CheckBox2 onChange={(e) => selectAll(e)} default={false} id={`ck-all-proj`} text="" />
                    <labe className="title-color"><b></b>{t('answers.selectAll')}</labe>
                  </div>}
                {answers
                  .filter(value => {
                    if (search == '') {
                      return value
                    } else if (value.name.toLowerCase().includes(search.toLowerCase())) {
                      return value
                    }
                  })
                  .sort(sortElements())
                  .map((answer, index) => (
                    <div
                      className="element"
                      key={index}
                      onClick={() => handleAnswer(answer)}
                    >
                      <div className="answer">
                        <CheckBox2 onChange={(e) => selectForDelete(e, answer)} default={false} id={`answer-${answer.id}`} text="" />
                        <div className='d-flex flex-column mr-3' style={{fontSize: 11}}>
                          <div id={'order_number_'+answer.id} className='m-1'></div>
                        </div>
                        {/*<div className="icon"></div>*/}
                        <div className='list-color ml-3' style={{fontSize: 14}}>{answer.name}</div>
                        
                      </div>
                      <div className="options_container">
                        <div className='d-flex flex-column mr-2' style={{fontSize: 10}}>
                          
                          <button onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            moveUp(e, answer, index);
                          }}>
                            <img src="/icons/arrow_up_simple.svg" alt="newAns" style={{ width: 25 }} />
                          </button>

                          <button onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            moveDown(e, answer, index);
                          }}>
                            <img src="/icons/arrow_down_simple.svg" alt="newAns" style={{ width: 25 }} />
                          </button>

                        </div>
                        <img
                          src="/icons/trash.png" style={{width: 25, height: 25}}
                          alt="trash" onClick={() => openModal(answer)}
                        />
                        <div className="more">
                          <div style={{ color: "#707070", fontSize: 14 }}>{t('common.settings')}</div>
                          <img src="/icons/Expand_left.svg" alt="expandLeft" style={{width: 30, height: 30}} />
                        </div>
                      </div>

                    </div>
                  ))}
              </div>
              {/* <div className="count">
                <h4>1 - {ref.current ? ref.current.children.length - 1 : 1}</h4>
              </div> */}
            </div>

            <div className="container-edit right-c">
              
                {sidePanel == 'edit' ? (
                  <AnswerCRUD
                    sidePanel={sidePanel}
                    setSidePanel={setSidePanel}
                    title={t('menu.editAnswer')}
                    edit={true}
                    setSelectedAnswer={setSelectedAnswer}
                    selectedAnswer={selectedAnswer}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    onAnswerUpdated={handleAnswerUpdated}
                  />
                ) : sidePanel == 'new' ? (
                  <AnswerCRUD
                    sidePanel={sidePanel}
                    setSidePanel={setSidePanel}
                    title={t('menu.createAnswer')}
                    edit={true}
                    setSelectedAnswer={setSelectedAnswer}
                    selectedAnswer={selectedAnswer}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    onAnswerUpdated={handleAnswerUpdated}
                  />
                ) : (
                  <AnswerCRUD
                    sidePanel={sidePanel}
                    setSelectedAnswer={setSelectedAnswer}
                    setSidePanel={setSidePanel}
                    title={t('answers.details')}
                    edit={true}
                    selectedAnswer={selectedAnswer}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    onAnswerUpdated={handleAnswerUpdated}
                  />
                )}
             
            </div>

          </div>

        </div>
      </section>
      <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" />
          <h1>{t('answers.deleteAnswer')}</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setIsModalOpen({ delete: false, code: false })}
              className="cancel btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button onClick={deleteAnswer} className="accept">
              {t('common.accept')}
            </button>
          </div>
        </div>
      </Modal>
      <Modal isOpen={modalDelete} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" alt='' />
          <h1>{t('answers.deleteAnswers')}</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setModalDelete(false)}
              className="cancel btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button onClick={() => { deleteMultiple() }} className="accept">
              {t('common.accept')}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
